import type { InputState } from "../hooks/useEngine";
import type { EngineError } from "../contracts/types";

interface InputEditorProps {
  value: string;
  state: InputState;
  errors: EngineError[];
  onChange: (value: string) => void;
}

const STATE_LABEL: Record<InputState, string> = {
  initial: "Fixture precargado",
  edited: "Editada — lista para ejecutar",
  invalid: "Entrada inválida",
  "too-large": "Demasiado grande",
};

export function InputEditor({ value, state, errors, onChange }: InputEditorProps) {
  const describedBy = errors.length > 0 ? "input-editor-errors" : "input-editor-hint";
  return (
    <div className="field">
      <label htmlFor="input-editor">
        Entrada (envolvente + documento OpenAPI) <span className={`state-badge state-badge--${state === "invalid" || state === "too-large" ? "critical" : "info"}`}>{STATE_LABEL[state]}</span>
      </label>
      <textarea
        id="input-editor"
        className="code"
        spellCheck={false}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-describedby={describedBy}
        aria-invalid={errors.length > 0}
      />
      {errors.length > 0 ? (
        <div className="field-error" id="input-editor-errors" role="alert">
          <p>No pudimos procesar esta entrada. Tus datos no se enviaron; corrige los campos señalados:</p>
          <ul>
            {errors.map((error, index) => (
              <li key={`${error.code}-${index}`}>
                <code>{error.path ?? "#"}</code>: {error.message}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="field-hint" id="input-editor-hint">
          Edita el JSON directamente. Se valida contra contracts/input.schema.json antes de ejecutar.
        </p>
      )}
    </div>
  );
}
